export const neutral = {
  1: { value: { base: '{colors.neutral.light.1}', _dark: '{colors.neutral.dark.1}' } },
  2: { value: { base: '{colors.neutral.light.2}', _dark: '{colors.neutral.dark.2}' } },
  3: { value: { base: '{colors.neutral.light.3}', _dark: '{colors.neutral.dark.3}' } },
  4: { value: { base: '{colors.neutral.light.4}', _dark: '{colors.neutral.dark.4}' } },
  5: { value: { base: '{colors.neutral.light.5}', _dark: '{colors.neutral.dark.5}' } },
  6: { value: { base: '{colors.neutral.light.6}', _dark: '{colors.neutral.dark.6}' } },
  7: { value: { base: '{colors.neutral.light.7}', _dark: '{colors.neutral.dark.7}' } },
  8: { value: { base: '{colors.neutral.light.8}', _dark: '{colors.neutral.dark.8}' } },
  9: { value: { base: '{colors.neutral.light.9}', _dark: '{colors.neutral.dark.9}' } },
  10: { value: { base: '{colors.neutral.light.10}', _dark: '{colors.neutral.dark.10}' } },
  11: { value: { base: '{colors.neutral.light.11}', _dark: '{colors.neutral.dark.11}' } },
  12: { value: { base: '{colors.neutral.light.12}', _dark: '{colors.neutral.dark.12}' } },
  a1: { value: { base: '{colors.neutral.light.a1}', _dark: '{colors.neutral.dark.a1}' } },
  a2: { value: { base: '{colors.neutral.light.a2}', _dark: '{colors.neutral.dark.a2}' } },
  a3: { value: { base: '{colors.neutral.light.a3}', _dark: '{colors.neutral.dark.a3}' } },
  a4: { value: { base: '{colors.neutral.light.a4}', _dark: '{colors.neutral.dark.a4}' } },
  a5: { value: { base: '{colors.neutral.light.a5}', _dark: '{colors.neutral.dark.a5}' } },
  a6: { value: { base: '{colors.neutral.light.a6}', _dark: '{colors.neutral.dark.a6}' } },
  a7: { value: { base: '{colors.neutral.light.a7}', _dark: '{colors.neutral.dark.a7}' } },
  a8: { value: { base: '{colors.neutral.light.a8}', _dark: '{colors.neutral.dark.a8}' } },
  a9: { value: { base: '{colors.neutral.light.a9}', _dark: '{colors.neutral.dark.a9}' } },
  a10: { value: { base: '{colors.neutral.light.a10}', _dark: '{colors.neutral.dark.a10}' } },
  a11: { value: { base: '{colors.neutral.light.a11}', _dark: '{colors.neutral.dark.a11}' } },
  a12: { value: { base: '{colors.neutral.light.a12}', _dark: '{colors.neutral.dark.a12}' } },
}
